export const INTERNAL_ERROR = '500 Internal Server Error'
